import React from 'react';
import MessageDebugItemSubItem from "./message-debug-item-subitems";

type Props = {
    title               : string
    expanded?           : boolean
    data                : any
    expandableSubItems? : boolean
}

export default function MessageDebugItem(props: Props) {

    const [expanded, setExpanded] = React.useState(props.expanded);

    const toggleExpanded = () => {
        setExpanded(!expanded);
    }

    return (
        <>
            <div className="flex-row-left-center m-b-10 m-t-10" onClick={toggleExpanded}>
                <div className={Classes(expanded ? "i5-big-angle-down" : "i5-big-angle-right", "fs-10", "m-r-5")}></div>
                <div className="ui5-title-tiny" >{props.title}</div>
            </div>

            <div style={{maxWidth: "100%", overflow: "wrap", wordBreak: "break-word"}}>
                {expanded &&
                    <>
                        {props.expandableSubItems &&
                            <>
                                {
                                    Object.keys(props.data).map(
                                        (key) => {
                                            return <MessageDebugItemSubItem title={key} data={props.data[key]}/>
                                        }
                                    )
                                }
                            </>
                        }
                        {!props.expandableSubItems && JSON.stringify(props.data, (key, value)=> {
                            return value
                        }, 2)}
                    </>
                }
            </div>

        </>
    );
}
